.hz{border:1px solid #ddd;}